<div class="d-flex justify-content-center align-items-center flex-column align-spinner-middle">
  <img brandingAssetSrc="icon/loading-glyph.gif" />
  <p class="loading-text ms-3">One moment...</p>
</div>
